import { graphql } from 'gatsby';
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Container from '~/layout/Container';
import BaseLink from '~/components/base/BaseLink';

import SiteSearch from '~/components/SiteSearch';

import { transition } from '~/styles/transition';
import trackCustomEvent from '~/utilities/trackCustomEvent';

const NavWrapper = styled.div`
    background-color: ${({ theme }) => theme.colors.text.black};

    @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}) {
        display: none;
    }
`;

const Navigation = styled.nav`
    color: ${({ theme }) => theme.colors.primary.white};
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    font-size: 1.4rem;
`;

const NavList = styled.ul`
    display: flex;
    gap: 30px;
    justify-content: flex-end;

    @media (min-width: ${({ theme }) => theme.breakpoint.largeTablet}) {
        margin: 0 -20px;
    }
`;

const NavItem = styled.li`
    display: flex;
    align-items: center;
`;

const NavLink = styled(BaseLink)`
    display: inline-block;
    padding: 5px 0;
    ${transition({}, 'text-decoration')};

    &:hover,
    &:focus {
        text-decoration: underline;
    }
`;

const TopNavigation = ({ data }) => {
    const {
        wpMenu: { menuItems }
    } = data;

    return (
        <NavWrapper>
            <Container maxWidth="maxWidth">
                <Navigation>
                    <NavList>
                        {menuItems.nodes.map((menuItem) => {
                            return (
                                <NavItem key={menuItem.id}>
                                    <NavLink
                                        to={menuItem.url}
                                        onClick={() =>
                                            trackCustomEvent(
                                                'top_navigation_click',
                                                { value: menuItem.url }
                                            )
                                        }
                                    >
                                        {menuItem.label}
                                    </NavLink>
                                    {menuItem.childItems.nodes.length ? (
                                        <ul>
                                            {menuItem.childItems.nodes.map(
                                                (childItem) => {
                                                    return (
                                                        <li key={childItem.id}>
                                                            <NavLink
                                                                to={
                                                                    childItem.url
                                                                }
                                                                onClick={() =>
                                                                    trackCustomEvent(
                                                                        'top_navigation_click',
                                                                        {
                                                                            value: childItem.url
                                                                        }
                                                                    )
                                                                }
                                                            >
                                                                {
                                                                    childItem.label
                                                                }
                                                            </NavLink>
                                                        </li>
                                                    );
                                                }
                                            )}
                                        </ul>
                                    ) : null}
                                </NavItem>
                            );
                        })}
                        <NavItem>
                            <SiteSearch />
                        </NavItem>
                    </NavList>
                </Navigation>
            </Container>
        </NavWrapper>
    );
};

TopNavigation.propTypes = {
    data: PropTypes.object.isRequired
};

export default TopNavigation;

export const query = graphql`
    query TopNavigation {
        wpMenu(locations: { eq: TOP_MENU }) {
            menuItems {
                nodes {
                    label
                    url
                    id
                    childItems {
                        nodes {
                            label
                            url
                            id
                        }
                    }
                }
            }
        }
    }
`;
